export default "__VITE_ASSET__DTWvSmFI__"